export class CreateEconomicGroupDTO  {
    idSimulation: number;
    idRegistrationManager: string;
  }